import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import draggable from "vuedraggable";
import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import Title from "@/pages/design/components/Title";
import InputBar from "@/pages/design/components/InputBar";
import FormEditPage from '@/pages/design/components/FormEditPage';
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ColorPicker: ColorPicker,
    Card: Card,
    CardItem: CardItem,
    Title: Title,
    InputBar: InputBar,
    FormEditPage: FormEditPage,
    draggable: draggable
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      defaultLangId: 0,
      curMenuItem: 0,
      showSlide: false,
      langList: [],
      defaultTitle: {}
    };
  },
  created: function created() {
    var _this = this;
    var langlist = localStorage.langList;
    langlist = JSON.parse(langlist);
    this.langList = langlist;

    // 根据localStorage初始化 titles
    if (langlist) {
      var keys = Object.keys(langlist);
      keys.forEach(function (item) {
        _this.defaultTitle[item] = '';
      });
    }
    var defaultLangObjStr = window.localStorage.cdefaultLangObj ? window.localStorage.cdefaultLangObj : window.localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj)
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  methods: {
    handleAddItem: function handleAddItem() {
      this.value.titles.push({
        title: {},
        link: ''
      });
      this.curMenuItem = this.value.titles.length - 1;
      this.showSlide = true;
    },
    handleDeleteItem: function handleDeleteItem() {
      this.value.titles.splice(this.curMenuItem, 1);
      this.showSlide = false;
    },
    handleListItemClick: function handleListItemClick(i) {
      this.curMenuItem = i;
      this.showSlide = true;
    }
  }
};